import styled, { css } from 'styled-components';
import { Typography } from '../../../../ui/Typography';
import { FlexibleDiv } from '../../../../../styled/common';

export const MapContainer = styled.div<{ isFullScreen: boolean }>`
  height: 140px;
  border-radius: 14px;
  overflow: hidden;
  width: 100%;
  position: relative;
`;

export const MapOverlay = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SelectMapButton = styled.button`
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.systemColors.blue};
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding: 10px 15px;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  height: 40px;
`;

export const SelectMapButtonText = styled(Typography)`
  color: ${({ theme }) => theme.colors.systemColors.blue};
`;

export const mapModalStyles = css`
  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    height: calc(100% - 130px);
    width: calc(100% - 150px);
    padding: 40px;

    > div {
      border-radius: 14px;
    }
  }
`;

export const saveButtonStyles = css`
  position: absolute;
  bottom: 30px;
  height: 54px;
  border-radius: 14px;
  z-index: 10;
  width: calc(100% - 30px);
  left: 15px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    left: unset;
    width: 340px;
    right: 70px;
    bottom: 70px;
  }
`;

export const closeButtonStyles = css`
  position: absolute;
  z-index: 10;
  top: 20px;
  left: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 13.5px 10px 10px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    left: unset;
    right: 70px;
    top: 70px;
  }
`;

export const LandmarksContainer = styled(FlexibleDiv)`
  flex-wrap: wrap;
  margin-top: 15px;
  gap: 10px;

  > label {
    margin: 0;
  }
`;

export const chipsStyles = css`
  height: 38px;
  border-radius: 20px;
  padding: 11.5px 15px;
`;
